import {
    SET_IS_ERROR_LEAD_CONVERSATION, SET_IS_LOADING_LEAD_CONVERSATION, SET_IS_SUCCESS_LEAD_CONVERSATION,
} from '../constants/get_lead_conversation.constants';


// This functionality is designed to concatenate several conversation arrays that come from the backend and eliminate
// duplicate messages in the final array. We compare the conversation fields with the same fields in the previous
// conversation array and leave no duplication.
const getConversationArray = (conversations) => {
    const conversationArray = [];

    conversations.forEach(({ conversation }, idx) => {
        const prevLastConversation = idx > 0 && conversations[idx - 1].conversation[conversations[idx - 1].conversation.length - 1];

        let isSame = false;

        if (idx > 0) {
            isSame = conversation[conversation.length - 1].body === prevLastConversation.body;
        }

        if (!isSame) {
            conversationArray.push(conversation[conversation.length - 1]);
        }
    });

    // conversations.forEach(({ conversation, created_date }, index) => {
    //     conversation.forEach(({ body, lastMessageDate }, idx) => {
    //         const prevConversation = conversations[index - 1]?.conversation[idx];
    //
    //         if (lastMessageDate && lastMessageDate !== prevConversation?.lastMessageDate) {
    //             conversationArray.push(conversation[idx]);
    //         } else if (body && body !== prevConversation?.body) {
    //             conversation[idx].lastMessageDate = created_date;
    //             conversationArray.push(conversation[idx]);
    //         }
    //     });
    // });

    return conversationArray;
};

const initialState = {
    isLoading: false, conversations: [], error: null,
};

export const leadConversation = (state = initialState, action) => {
    switch (action.type) {
    case SET_IS_LOADING_LEAD_CONVERSATION:
        return {
            ...state, isLoading: action.isLoading,
        };
    case SET_IS_SUCCESS_LEAD_CONVERSATION:
        return {
            ...state, conversations: getConversationArray(action.payload),
        };
    case SET_IS_ERROR_LEAD_CONVERSATION:
        return {
            ...state, error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/lead_conversation.reducers.js